'use client';

import { useScopedI18n } from '@/locales/client';
import Link from 'next/link';
import type { ReactElement } from 'react';

export default function Legal(): ReactElement {
  const t = useScopedI18n('footer');
  return (
    <div className="w-full flex items-center justify-center gap-2 sm:gap-3 text-center">
      <p className="font-light text-xs sm:text-base opacity-80 hover:opacity-100">{t('cookies')}</p>
      <Link
        href="/files/user-agreement.pdf"
        className="font-light text-xs sm:text-base opacity-80 hover:opacity-100"
        target="_blank"
      >
        {t('agreement')}
      </Link>
    </div>
  );
}
